export default __webpack_public_path__ + "a8b0bd30465b1d29c221a7b296f92882.jpg";